import styled from "styled-components";

export const GhostButton = styled.div`
  width: auto;
  float: left;
  padding: 5px;
  border-radius: 6px 0 6px 0;
  border: 1px solid dimgray;
`;
